// Import styles
import "../styles/divi/divi.scss";

// No additional JavaScript needed - keep it minimal to avoid conflicts

console.log("Divi load");